export interface AppDefinition {
  id: string
  url: string
  icon: string
  color: string
}

export const apps: AppDefinition[] = [
  {
    id: 'monitoring',
    url: import.meta.env.VITE_APP_MONITORING_URL || 'http://localhost:5173',
    icon: 'activity',
    color: '#0ea5e9',
  },
  {
    id: 'user-management',
    url:
      import.meta.env.VITE_APP_USER_MANAGEMENT_URL || 'http://localhost:5176',
    icon: 'users',
    color: '#10b981',
  },
  {
    id: 'notification-manager',
    url:
      import.meta.env.VITE_APP_NOTIFICATION_MANAGER_URL ||
      'http://localhost:5179',
    icon: 'bell',
    color: '#f97316',
  },
  {
    id: 'map-manager',
    url: import.meta.env.VITE_APP_MAP_MANAGER_URL || 'http://localhost:5178',
    icon: 'folder-open',
    color: '#14b8a6',
  },
  {
    id: 'map-editor',
    url: import.meta.env.VITE_APP_MAP_EDITOR_URL || '',
    icon: 'map',
    color: '#f59e0b',
  },
  {
    id: 'playback-editor',
    url: import.meta.env.VITE_APP_PLAYBACK_EDITOR_URL || '',
    icon: 'waypoints',
    color: '#3b82f6',
  },
  {
    id: 'web-simulator',
    url: import.meta.env.VITE_APP_SIMULATOR_URL || '',
    icon: 'monitor-play',
    color: '#ec4899',
  },
  {
    id: 'device-manager',
    url: import.meta.env.VITE_APP_DEVICE_MANAGER_URL || 'http://localhost:5181',
    icon: 'forklift',
    color: '#6366f1',
  },
  {
    id: 'api-tester',
    url: import.meta.env.VITE_APP_ROUTE_SEARCH_URL || 'http://localhost:5175',
    icon: 'flask-conical',
    color: '#8b5cf6',
  },
  {
    id: 'map-editor-stg',
    url: import.meta.env.VITE_APP_MAP_EDITOR_STG_URL || '',
    icon: 'map',
    color: '#8b5cf6',
  },
  {
    id: 'map-editor-dev',
    url: import.meta.env.VITE_APP_MAP_EDITOR_DEV_URL || '',
    icon: 'map',
    color: '#8b5cf6',
  },
]
